module.exports = __webpack_public_path__ + "files/85baf3d6c90ef8f7a803c2aaf7a4fcc2.png";